import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {Page} from "../flipp-page/Page";
import renderBreadcrumbs from "../renderBreadcrumbs";
import BreadcrumbsService from "../../services/BreadcrumbsService";
import {inject} from "../../services/di";
import { SeoService } from "../../services/SeoService";

interface ILocationsBrowser {
	locations: string;
}

@element("flipp-location-browser")
export class LocationBrowser extends Component<ILocationsBrowser, {}> {
	@attr locations: string;
	@inject breadcrumbsService: BreadcrumbsService;
	@inject seoService: SeoService;

	renderTree(locations: any): HTMLElement {
		return (
			<ol>
				{locations.map((l: any) => (
					<div>
						<li><a href={l.url}>{l.name}</a></li>
					</div>
				))}
			</ol>
		);
	}

	render() {
		const locations = JSON.parse(this.props.locations);
		const breadcrumbs = this.breadcrumbsService.getBrowserBreadcrumbs();
		const currentLocation = this.breadcrumbsService.getCurrentLocation();

		this.seoService.insertLoadingMarker(70);
		return (
			<Page show="flyers">
				{renderBreadcrumbs(breadcrumbs, currentLocation)}
				{this.renderTree(locations)}
			</Page>
		);
	}
}
